import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { breakpoints } from '@avangard/ui/utils';
import { gray, green, red } from '@avangard/ui/colors';

import { DashboardWidget } from '@modules/dashboard/organisms';
import { StudentPerformanceStatsFilters } from './student-performance-stats-filters';

import type { OnlineStudentPerformanceCourseEntity } from '@modules/students/entities';

type StudentPerformanceStatsProps = {
    coursePerformance: OnlineStudentPerformanceCourseEntity;
};

const Root = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 24px;

    ${breakpoints.down('xs')} {
        margin-bottom: 12px;
    }
`;

const Widget = styled(DashboardWidget)`
    max-width: 250px;
    width: 100%;
`;

const Content = styled.div<{ success: boolean }>`
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    color: ${p => (p.success ? green[100] : red[100])};
    font-size: 3.4rem;
    font-weight: 600;

    span {
        margin: 0 8px;
        color: ${gray[80]};
    }
`;

const StudentPerformanceStats = (props: StudentPerformanceStatsProps): React.ReactElement => {
    const { coursePerformance } = props;

    const { t } = useTranslation(['students']);

    return (
        <Root>
            <Widget label={t('students:widgets.course_test.title')}>
                <Content success={coursePerformance.resultSuccess}>
                    {coursePerformance.scoreInPoints}
                    <span>/</span>
                    {coursePerformance.score}
                </Content>
            </Widget>

            <StudentPerformanceStatsFilters />
        </Root>
    );
};

export { StudentPerformanceStats };
